// src/profileOptions.ts
// Choices people can make to customize their profile.
import type { IconName } from "./components/Icon";

export const AVATARS: { icon: IconName; label: string }[] = [
  { icon: "happy", label: "Smiley" },
  { icon: "heart", label: "Heart" },
  { icon: "stars", label: "Moon and stars" },
  { icon: "sun", label: "Sun" },
  { icon: "cloud", label: "Cloud" },
  { icon: "tea", label: "Tea" },
  { icon: "coffee", label: "Coffee" },
  { icon: "book", label: "Book" },
  { icon: "music", label: "Music" },
  { icon: "headphone", label: "Headphones" },
  { icon: "gamepad", label: "Game controller" },
  { icon: "dino", label: "Dinosaur" },
  { icon: "robot", label: "Robot" },
  { icon: "bug", label: "Little bug" },
  { icon: "cake", label: "Cake" },
  { icon: "art", label: "Paint swatches" },
  { icon: "camera", label: "Camera" },
  { icon: "chess", label: "Chess piece" },
  { icon: "zap", label: "Lightning" },
  { icon: "waving", label: "Waving person" },
];

export type TileTone = "pink" | "blue" | "gold" | "green" | "violet";
export const AVATAR_TONES: TileTone[] = ["pink", "blue", "gold", "green", "violet"];

export type ThemeTone = "pink" | "blue" | "tan" | "lavender" | "mint";
export const THEMES: { tone: ThemeTone; label: string; swatch: string }[] = [
  { tone: "pink", label: "Bubblegum", swatch: "#f5a9b8" },
  { tone: "blue", label: "Sky", swatch: "#9fe0fb" },
  { tone: "tan", label: "Kraft paper", swatch: "#e9d2ad" },
  { tone: "lavender", label: "Lavender", swatch: "#cdb4f0" },
  { tone: "mint", label: "Mint", swatch: "#a8e6c4" },
];

export type Pattern = "plain" | "hearts" | "stars" | "checks" | "dots";
export const PATTERNS: { value: Pattern; label: string }[] = [
  { value: "plain", label: "Plain" },
  { value: "hearts", label: "Hearts" },
  { value: "stars", label: "Stars" },
  { value: "checks", label: "Checkers" },
  { value: "dots", label: "Polka dots" },
];

// Full class names so Tailwind keeps them (it drops names built at runtime).
export const PATTERN_CLASS: Record<Pattern, string> = {
  plain: "",
  hearts: "pattern-hearts",
  stars: "pattern-stars",
  checks: "pattern-checks",
  dots: "pattern-dots",
};

export const SPOON_LABELS = [
  "",
  "running on empty",
  "low spoons",
  "getting by",
  "pretty good",
  "full drawer!",
];

export const REPLY_PACES = [
  { value: "days", label: "within a few days" },
  { value: "week", label: "in about a week" },
  { value: "weeks", label: "in a couple of weeks" },
  { value: "spoons", label: "whenever I have the spoons" },
];

export const ACCESS_OPTIONS = [
  "Plain language, please",
  "I use a screen reader",
  "Content notes welcome",
  "Short letters are perfect",
  "Long letters welcome",
  "Text only, no voice or video",
  "I may go quiet for a while, it's not you",
  "Brain fog: I might repeat myself",
  "Typos happen, no big deal",
  "Please be direct, I miss hints",
];

export const STICKERS = [
  "Trans joy",
  "Nonbinary",
  "Spoonie life",
  "Chronic illness",
  "Neurodivergent",
  "Mad pride",
  "Deaf / HoH",
  "Mobility aid gang",
  "Crafts",
  "Crochet & knitting",
  "Art",
  "Zines",
  "Writing",
  "Reading",
  "Music",
  "Film & TV",
  "Anime",
  "Gaming",
  "Cozy games",
  "The Sims",
  "Tarot & witchy stuff",
  "Nature",
  "Gardening",
  "Fishing",
  "Cooking & baking",
  "Cats",
  "Dogs",
  "Critters",
  "Fandom",
  "Queer history",
  "Activism",
  "Science",
];

export const MAX_STICKERS = 8;

export const CURRENTLY_FIELDS = [
  { key: "reading", label: "Reading" },
  { key: "listening", label: "Listening to" },
  { key: "playing", label: "Playing" },
  { key: "watching", label: "Comfort show" },
] as const;

export type Currently = Partial<Record<(typeof CURRENTLY_FIELDS)[number]["key"], string>>;
